import React from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { FormProvider as HooksFormProvider } from 'react-hook-form';
import type { UseFormReturn } from 'react-hook-form/dist/types';
import type { FieldValues } from 'react-hook-form/dist/types/fields';

import { generateDataTestId } from '@/lib/tests';
import type { WithChildren } from '@/lib/types';

export interface FormProviderProps<
  TFieldValues extends FieldValues = any,
  TContext = any,
> extends WithChildren,
    UseFormReturn<TFieldValues, TContext> {
  background?: string;
  className?: string;
  formProps?: Omit<
    React.DetailedHTMLProps<
      React.FormHTMLAttributes<HTMLFormElement>,
      HTMLFormElement
    >,
    'onSubmit'
  >;
  name: string;
  onSubmit: SubmitHandler<TFieldValues>;
}

/**
 * Simple wrapper to avoid manually adding RHF FormProvider & required form.
 */
export const FormProvider = ({
  background,
  children,
  className,
  formProps,
  name,
  onSubmit,
  ...providerProps
}: FormProviderProps) => {
  return (
    <HooksFormProvider {...providerProps}>
      <form
        data-test-id='FormProviderForm'
        onSubmit={providerProps.handleSubmit(onSubmit, (err) =>
          console.log(err),
        )}
        style={{ width: '100%', background }}
        {...generateDataTestId('form', name)}
        name={name}
        {...formProps}
        className={className}
        noValidate
      >
        {children}
      </form>
    </HooksFormProvider>
  );
};
